export const toastSetting = {
  success: {
    type: "success",
    isLoading: false,
    autoClose: 4000,
    closeButton: true,
    closeOnClick: true,
    position: "bottom-right",
  },
  error: {
    type: "error",
    isLoading: false,
    autoClose: 4000,
    closeButton: true,
    closeOnClick: true,
    position: "bottom-right",
  },
    info: {
    type: "info",
    isLoading: false,
    autoClose: 4000,
    closeButton: true,
    closeOnClick: true,
    position: "bottom-right",
  }
}
